import React from 'react';

function Ignore() {
  return React.Fragment;
}

export default Ignore;
